<template>
  <div id="app">
    <div class="container" v-show="!this.$root.loading">
      <div class="row">
        <div class="col">
          <img alt="Urb Logo" src="./assets/logo.png" width="120px" />
        </div>
      </div>
      <router-view />
      <div id="footer" class="row">
        <div class="col">
          <p>
            Urb Labs
          </p>
        </div>
      </div>
    </div>
    <div class="container" v-show="this.$root.loading">
      <div class="row">
        <div class="col">
          <img alt="Urb Loading" src="./assets/loader.gif" width="120px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "./configs/firebase.js";

export default {
  name: "App",
  created() {
    this.$root.loading = true;
    auth.useDeviceLanguage();
  },
  mounted() {
    auth.onAuthStateChanged((user) => {
      this.$root.user = user;

      if (user) {
        if (this.$route.path != "/confirm") {
          this.$router.push({ path: "/confirm" });
        }
      } else {
        if (this.$route.path == "/confirm") {
          if (
            this.$root.isRedirect &&
            this.$root.key != null &&
            this.$root.key_secret != null
          ) {
            window.location.href =
              this.$root.callback +
              "?external=" +
              this.$root.external +
              "&key=" +
              this.$root.key +
              "&key_secret=" +
              this.$root.key_secret;
          } else {
            this.$router.push({ path: "/" });
          }
        }
      }

      this.$root.loading = false;
    });
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 30px;
  margin: auto;
}

#footer {
  margin-top: 60px;
}
</style>
